<template>
  <svg :preserveAspectRatio="preserveAspectRatio" :viewBox="viewBox" :style="styleRules">
    <use v-if="brandInfo" :href="logoRef" />
  </svg>
</template>

<script>
import { isUndefined, get } from 'lodash-es'
import BrandMixin from '@/js/mixins/brand-mixin'

export const BRAND_LOGO_CONSTANTS = {
  EVENTS: {
    LOGO_DATA_AVAILABLE: 'logoDataPresent',
  },
}

const alignments = {
  left: 'xMinYMid meet',
  center: 'xMidYMid meet',
  right: 'xMaxYMid meet',
}

export default {
  name: 'BrandLogoRef',
  mixins: [BrandMixin],
  props: {
    brand: {
      type: [String, Number],
      default: '',
    },
    align: {
      type: String,
      default: 'center',
    },
    maxHeight: {
      type: String,
      default: undefined,
    },
    maxWidth: {
      type: String,
      default: undefined,
    },
    client: {
      type: String,
      default: '',
    },
  },
  computed: {
    styleRules() {
      return `${
        this.maxHeight
          ? `max-height:${this.maxHeight};width:calc(${this.maxHeight} * ${
              get(this.viewBoxParts, 2, 1) / get(this.viewBoxParts, 3, 1)
            });`
          : ''
      }${
        this.maxWidth
          ? `max-width:${this.maxWidth};height:calc(${this.maxWidth} * ${
              get(this.viewBoxParts, 3, 1) / get(this.viewBoxParts, 2, 1)
            });`
          : ''
      }`
    },
    preserveAspectRatio() {
      return get(alignments, this.align) || get(alignments, 'center')
    },
    brandName() {
      return get(this.brandInfo, 'pimBrandName', '').toLowerCase()
    },
    logoRef() {
      return `#logo-${this.brandName}`
    },
  },
  watch: {
    logoData: {
      immediate: true,
      handler: function (newData, oldData) {
        if (newData === oldData) {
          return
        }

        if (isUndefined(newData)) {
          this.$emit(BRAND_LOGO_CONSTANTS.EVENTS.LOGO_DATA_AVAILABLE, false)
        } else if (!isUndefined(newData)) {
          this.$emit(BRAND_LOGO_CONSTANTS.EVENTS.LOGO_DATA_AVAILABLE, true)
        }
      },
    },
  },
}
</script>

<style lang="scss" module>
.brand {
  position: relative;

  display: inline-block;
  width: auto;
  height: auto;
}
</style>
